import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const roleApi = {
  getRoles: async ({ page = 1, perPage = 10, search = '', includeTrashed = false, paginate = true } = {}) => { // Added paginate parameter
    try {
      const params = { search, trashed: includeTrashed ? 'true' : 'false' };
      if (paginate) {
        params.page = page;
        params.per_page = perPage;
      } else {
        params.paginate = false; // Send paginate=false to backend
      }

      const response = await apiClient.get(`${API_ENDPOINTS.ROLES}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  },

  getRoleByIdentifier: async (identifier) => {
    try {
      const url = `${API_ENDPOINTS.ROLES}/${identifier}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching role ${identifier}:`, error);
      throw error;
    }
  },

  createRole: async (roleData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.ROLES}`, roleData);
      return response.data;
    } catch (error) {
      console.error('Error creating role:', error);
      throw error;
    }
  },

  updateRole: async (identifier, roleData) => {
    try {
      roleData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.ROLES}/${identifier}`, roleData);
      return response.data;
    } catch (error) {
      console.error(`Error updating role ${identifier}:`, error);
      throw error;
    }
  },

  trashRole: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.ROLES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing role ${identifier}:`, error);
      throw error;
    }
  },

  restoreRole: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.ROLES}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring role ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteRole: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.ROLES}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting role ${identifier}:`, error);
      throw error;
    }
  },
};

export default roleApi;